export default __webpack_public_path__ + "static/media/pen.f9507280.svg";